import { render, staticRenderFns } from "./financeDetail.vue?vue&type=template&id=66df638d&scoped=true&"
import script from "./financeDetail.vue?vue&type=script&lang=js&"
export * from "./financeDetail.vue?vue&type=script&lang=js&"
import style0 from "./financeDetail.vue?vue&type=style&index=0&id=66df638d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df638d",
  null
  
)

export default component.exports